import {
  TASK_STATUS,
  TASK_TYPE,
  TASK_VISIBILITY,
  USER_TASK_CONTEXT,
} from 'shared/common/enums'

import { isTask } from 'shared/utils/type-guards/graphql-types'

// TYPE

export const isBaseTask = (arg: any) =>
  isTask(arg) && arg.taskType === TASK_TYPE.regular

export const isEventTask = (arg: any) =>
  isTask(arg) && arg.taskType === TASK_TYPE.event

export const isGroupTask = (arg: any) =>
  isTask(arg) && arg.taskType === TASK_TYPE.group

// STATUS

export const isTaskDone = (arg: any) =>
  isTask(arg) && arg.status === TASK_STATUS.done

export const isTaskNotApplicable = (arg: any) =>
  isTask(arg) && arg.status === TASK_STATUS.notApplicable

// VISIBILITY

export const isTaskHidden = (arg: any) =>
  isTask(arg) && arg.visibility === TASK_VISIBILITY.hidden

// USER CONTEXT

export const isUserParticipant = (arg: any) =>
  isTask(arg) && arg.currentUserTaskContext === USER_TASK_CONTEXT.participant

export const isUserAssignee = (arg: any) =>
  isTask(arg) && arg.currentUserTaskContext === USER_TASK_CONTEXT.assignee
